import { render, staticRenderFns } from "./OverflowTooltip.vue?vue&type=template&id=2ac63100&scoped=true&"
import script from "./OverflowTooltip.vue?vue&type=script&lang=js&"
export * from "./OverflowTooltip.vue?vue&type=script&lang=js&"
import style0 from "./OverflowTooltip.vue?vue&type=style&index=0&id=2ac63100&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac63100",
  null
  
)

export default component.exports